import type { CSSProperties, RefObject } from 'react';

import type { JSONContent } from '@tiptap/core';

import {
  stylizedSidebarCalloutToolbarStyles,
} from './stylizedSidebarCalloutEditorStyles';
import { InteractionRichTextField } from './InteractionRichTextField';
import type { InteractionRichTextToolbarStyles } from './interactionEditorUtils';

const toolbarStyles: InteractionRichTextToolbarStyles = {
  toolbar: stylizedSidebarCalloutToolbarStyles.toolbar,
  button: stylizedSidebarCalloutToolbarStyles.toolbarButton,
  activeButton: stylizedSidebarCalloutToolbarStyles.toolbarButtonActive,
};

interface StylizedSidebarCalloutFieldEditorProps {
  content: JSONContent;
  placeholder: string;
  allowLists?: boolean;
  isFocused: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onContentChange: (content: JSONContent) => void;
  autoFocus: boolean;
  containerRef: RefObject<HTMLDivElement | null>;
  fieldContainerStyle?: CSSProperties;
  editorStyle?: CSSProperties;
  editorClassName?: string;
  minHeight?: string;
  hideToolbar?: boolean;
  defaultBold?: boolean;
}

export function StylizedSidebarCalloutFieldEditor({
  content,
  placeholder,
  allowLists: _allowLists = false,
  isFocused,
  onFocus,
  onBlur,
  onContentChange,
  autoFocus,
  containerRef,
  fieldContainerStyle,
  editorStyle,
  editorClassName,
  minHeight = '24px',
  hideToolbar = false,
  defaultBold,
}: StylizedSidebarCalloutFieldEditorProps): React.ReactElement {
  return (
    <div style={fieldContainerStyle}>
      <InteractionRichTextField
        content={content}
        placeholder={placeholder}
        isFocused={isFocused}
        onFocus={onFocus}
        onBlur={onBlur}
        onContentChange={onContentChange}
        autoFocus={autoFocus}
        containerRef={containerRef}
        editorClassName={['tiptap', 'ssc-editor', editorClassName].filter(Boolean).join(' ')}
        editorInlineStyle={`outline: none; min-height: ${minHeight}; width: 100%;`}
        editorStyle={editorStyle}
        toolbarPreset="full"
        toolbarStyles={toolbarStyles}
        shouldRerenderOnTransaction
        hideToolbar={hideToolbar}
        defaultBold={defaultBold}
      />
    </div>
  );
}
